<template>
    <div
        class="s-show" :class="{'half':half}">
        <!--label-->
        <b
            class="s-show-label"
            :style="{width:labelWidth}"
            v-if="!hideLabel"
            :class="{must:item.must}">
            {{item.label}}：
        </b>
        <div class="s-show-cont">
            {{showData()}}
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    // 本地枚举
    import mjJson from '../../static/js/meiju.json'
    import showSItem from './showSItem'

    export default {
        name: 'sInputShow',
        props: ['item', 'size', 'half', 'labelWidth', 'hideLabel'],
        data() {
            return {
                mjJson: mjJson,
                // 输入框前缀Icon
                prefix: '',
                // 输入框后缀Icon
                suffix: '',
                // 提示
                placeholder: '',
                // 禁止选择
                disabled: false,
                // 只读
                readonly: false,
                // 是否添加清除按钮
                clearable: false,
                maxlength: null,
                // 展示类型
                showType: ''
            }
        },

        created() {
            // 赋值属性字段
            const attr = ['prefix', 'suffix', 'placeholder', 'disabled', 'maxlength', 'readonly', 'clearable', 'showType'];
            attr.map((key) => {
                if (this.item[key]) {
                    this[key] = this.item[key]
                }
            })
        },
        watch: {
            item: {
                handler(newData, oldData) {
                    // console.log(newData)
                },
                immediate: true,//关键
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            /**
             * 展示数据
             * @returns {*}
             */
            showData() {
                let obj = showSItem([this.item]);
                return obj[this.item.label]
            }
        }
    }
</script>

<style lang="scss">
    .s-show {
        width: 100%;
        display: flex;
        line-height: 30px;
        font-size: 15px;

        &-label {
            width: 100px;
            text-align: right;
            flex-shrink: 0;
            /*放大比例*/
            flex-grow: 0;

        }

        &-cont {
            flex-shrink: 1;
            /*放大比例*/
            flex-grow: 1;
        }

        &.half {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/s-input/sInputShow.vue